// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"k_bj","subcategoryColumn":"k_bk","articleLink":"k_bl","articleCoverImage":"k_bm","articleTitle":"k_bn"};